module.exports = __webpack_public_path__ + "img/author_icon.061541f7.svg";